export default "__VITE_ASSET__DEEuBOog__"